import script from "./KPIView.vue?vue&type=script&setup=true&lang=ts"
export * from "./KPIView.vue?vue&type=script&setup=true&lang=ts"

import "./KPIView.vue?vue&type=style&index=0&id=763552af&lang=css"

const __exports__ = script;

export default __exports__